var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ticketForm",
      class: { "view-form-disabled": _vm.type === "view" },
    },
    [
      _c(
        "div",
        { staticClass: "applyFormContent" },
        [
          _vm.type === "view"
            ? _c(
                "el-tabs",
                {
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.handleTabClick },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c("el-tab-pane", {
                    attrs: { label: "工单信息", name: "1" },
                  }),
                  _c("el-tab-pane", { attrs: { label: "日志", name: "2" } }),
                ],
                1
              )
            : _vm._e(),
          _vm.activeTab == "1"
            ? [
                _c(
                  "el-form",
                  {
                    ref: "ticketForm",
                    attrs: {
                      model: _vm.ticketForm,
                      rules: _vm.ticketFormRules,
                      "label-width": "150px",
                    },
                  },
                  [
                    _c("h3", { staticClass: "section-title" }, [
                      _vm._v("基本信息"),
                    ]),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "发起人" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    value: _vm.ticketUserInfo.nick_name,
                                    disabled: "",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "客户名称",
                                  prop: "customer_id",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      remote: "",
                                      "remote-method": _vm.getCompanyList,
                                      clearable: "",
                                      filterable: "",
                                      disabled: _vm.isView,
                                      placeholder: "请输入公司名称",
                                    },
                                    on: { change: _vm.changeTicketCustomer },
                                    model: {
                                      value: _vm.ticketForm.customer_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ticketForm,
                                          "customer_id",
                                          $$v
                                        )
                                      },
                                      expression: "ticketForm.customer_id",
                                    },
                                  },
                                  _vm._l(_vm.companyList, function (item) {
                                    return _c("el-option", {
                                      key: item.id,
                                      attrs: {
                                        label:
                                          item.company_name +
                                          "（" +
                                          item.id +
                                          "）",
                                        value: item.id,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "订单号", prop: "order_no" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      clearable: "",
                                      filterable: "",
                                      disabled: _vm.isView,
                                      placeholder: "请选择客户后带出",
                                    },
                                    model: {
                                      value: _vm.ticketForm.order_no,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ticketForm,
                                          "order_no",
                                          $$v
                                        )
                                      },
                                      expression: "ticketForm.order_no",
                                    },
                                  },
                                  _vm._l(_vm.ticketOrderList, function (item) {
                                    return _c("el-option", {
                                      key: item,
                                      attrs: { label: item, value: item },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "咨询事项",
                                  prop: "category_id",
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    attrs: { disabled: _vm.isView },
                                    on: {
                                      change: _vm.changeTicketFirstCategory,
                                    },
                                    model: {
                                      value: _vm.ticketForm.category_id,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.ticketForm,
                                          "category_id",
                                          $$v
                                        )
                                      },
                                      expression: "ticketForm.category_id",
                                    },
                                  },
                                  [
                                    _vm._l(
                                      _vm.ticketCategoryTree,
                                      function (item) {
                                        return _c(
                                          "el-radio",
                                          {
                                            key: item.id,
                                            attrs: { label: item.id },
                                          },
                                          [_vm._v(_vm._s(item.name))]
                                        )
                                      }
                                    ),
                                    _c("el-radio", { attrs: { label: "0" } }, [
                                      _vm._v("其他"),
                                    ]),
                                  ],
                                  2
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.ticketForm.category_id
                      ? _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "二级事项",
                                      prop: "second_category_id",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        attrs: { disabled: _vm.isView },
                                        on: {
                                          change:
                                            _vm.changeTicketSecondCategory,
                                        },
                                        model: {
                                          value:
                                            _vm.ticketForm.second_category_id,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ticketForm,
                                              "second_category_id",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "ticketForm.second_category_id",
                                        },
                                      },
                                      [
                                        _vm._l(
                                          _vm.ticketSecondCategoryOptions,
                                          function (item) {
                                            return _c(
                                              "el-radio",
                                              {
                                                key: item.id,
                                                attrs: { label: item.id },
                                              },
                                              [_vm._v(_vm._s(item.name))]
                                            )
                                          }
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "0" } },
                                          [_vm._v("其他")]
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.ticketForm.second_category_id
                      ? _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "具体事项",
                                      prop: "item_id",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        attrs: { disabled: _vm.isView },
                                        on: {
                                          change:
                                            _vm.generateTicketDefaultTitle,
                                        },
                                        model: {
                                          value: _vm.ticketForm.item_id,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.ticketForm,
                                              "item_id",
                                              $$v
                                            )
                                          },
                                          expression: "ticketForm.item_id",
                                        },
                                      },
                                      [
                                        _vm._l(
                                          _vm.ticketItemOptions,
                                          function (item) {
                                            return _c(
                                              "el-radio",
                                              {
                                                key: item.id,
                                                attrs: { label: item.id },
                                              },
                                              [_vm._v(_vm._s(item.name))]
                                            )
                                          }
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "0" } },
                                          [_vm._v("其他")]
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "工单标题", prop: "title" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: 50,
                                    disabled: _vm.isView,
                                    "show-word-limit": "",
                                    placeholder: "请输入工单标题",
                                  },
                                  model: {
                                    value: _vm.ticketForm.title,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ticketForm, "title", $$v)
                                    },
                                    expression: "ticketForm.title",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "事项描述",
                                  prop: "description",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    type: "textarea",
                                    rows: 5,
                                    maxlength: 500,
                                    disabled: _vm.isView,
                                    "show-word-limit": "",
                                    placeholder:
                                      "详细描述遇到的问题 或 需要协助的事项",
                                  },
                                  model: {
                                    value: _vm.ticketForm.description,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.ticketForm,
                                        "description",
                                        $$v
                                      )
                                    },
                                    expression: "ticketForm.description",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.activeTab == "2"
            ? [
                _c(
                  "el-table",
                  {
                    attrs: {
                      border: "",
                      "header-cell-style": {
                        background: "#f1f1f1",
                        color: "#333333",
                      },
                      align: "center",
                      data: _vm.logList,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        label: "操作人",
                        prop: "operation_name",
                        width: "150",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作内容", prop: "content" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(scope.row.content),
                                  },
                                }),
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(scope.row.note),
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4134199277
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "操作时间",
                        prop: "created_at",
                        width: "150",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "pages",
                    staticStyle: { "text-align": "right", margin: "16px 0" },
                  },
                  [
                    _c("el-pagination", {
                      attrs: {
                        background: "",
                        "current-page": _vm.logPages.currentPage,
                        "page-size": _vm.logSearchForm.pageSize,
                        "page-sizes": [20, 50, 100, 200, 500],
                        total: _vm.logPages.totalCount,
                        layout: "total,sizes, prev, pager, next, jumper",
                        "hide-on-single-page": true,
                      },
                      on: {
                        "current-change": _vm.handlePageChange,
                        "size-change": _vm.sizeChange,
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm.type !== "view"
        ? _c(
            "div",
            { staticClass: "form-footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.ticketSubmitLoading },
                  on: { click: _vm.submitTicketForm },
                },
                [_vm._v("提 交")]
              ),
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.ticketSubmitLoading },
                  on: { click: _vm.handleCancel },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }